/* eslint-disable no-plusplus, class-methods-use-this, no-underscore-dangle, jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-to-interactive-role */
import axios from 'axios';
import React from 'react';
import { jt, t } from 'ttag';
import Price from 'utils/prices';
import SmartImage from '../reusable-components/Image/SmartImage';
import smoothScroll from '../utils/smoothScroll';
import CartCta from './components/AddToCart/CartCta';
import SocialText from './components/SocialText';
import './style.scss';

const client = axios.create({
  headers: { 'X-Requested-With': 'XMLHttpRequest' }
});

class App extends React.Component {
  constructor(props) {
    super(props);
    const predefinedChoices = [];
    let i = 0;
    for (i = 0; i < window.__INITIAL_STATE__.giftcard_prices.length; i++) {
      predefinedChoices.push({
        id: i,
        value: window.__INITIAL_STATE__.giftcard_prices[i],
        selected: false
      });
    }

    this.state = {
      slug: 'https://thumblr.uniid.it/campaign/gift-card-2019/',
      imagePattern: '-gift-card-com',
      // translations: window.campaign_data.campaign_translations.blocks,
      // commonTranslations: window.campaign_data.common_translations.blocks,
      lang: window.config.language_code,
      initialPredefiendChoices: predefinedChoices,
      predefinedChoices,
      inputValue: '',
      giftcards: [],
      currency: window.config.default_currency,
      price: '',
      showInputInvalid: false,
      isFocused: false,
      siteName: window.config.siteName
    };
  }

  componentDidMount() {
    client
      .get(
        `/api/products/batch/?list=${window.__INITIAL_STATE__.product_ids.join()}`
      )
      .then(response => {
        const { products } = response.data;
        const giftcards = [];
        let i = 0;
        for (i = 0; i < products.length; i++) {
          const { id, name, image } = products[i];
          giftcards.push({
            id: parseInt(id, 10),
            name,
            src: image,
            selected:
              parseInt(id, 10) ===
              parseInt(window.__INITIAL_STATE__.preselected, 10)
          });
        }

        this.setState({
          giftcards
        });
      });
  }

  getSelected(arr) {
    for (let i = 0; i < arr.length; i++) {
      const { id, selected } = arr[i];
      if (selected) return id;
    }
    return '';
  }

  scrollTo(location) {
    if (location !== '') {
      setTimeout(() => smoothScroll(location, 150), 350);
    }
  }

  validateInput(val) {
    const pattern = /^[1-9][0-9]*$/;
    return pattern.test(val);
  }

  returnPredefined(obj, currency) {
    return obj.map(item => {
      const price = new Price(item.value, currency);
      return (
        <div
          role="button"
          tabIndex="0"
          className={item.selected ? 'outline' : ''}
          key={item.id}
          onClick={() => {
            // this.scrollTo2('gc-step3');
            this.setState(prevState => ({
              inputValue: '',
              price: item.value,
              predefinedChoices: prevState.predefinedChoices.map(el =>
                el.id === item.id
                  ? { ...el, selected: true }
                  : { ...el, selected: false }
              )
            }));
          }}
        >
          {price.toString()}
        </div>
      );
    });
  }

  render() {
    const {
      predefinedChoices,
      giftcards,
      currency,
      inputValue,
      showInputInvalid,
      siteName,
      lang,
      slug,
      imagePattern,
      isFocused,
      price
    } = this.state;
    return (
      <main id="gift-card">
        {/* HEADER */}
        <section className="engage-section mainWidth">
          <SmartImage
            className="heightEngage engageSmartImage innerWidth"
            lang={lang}
            slug={slug}
            imagePattern={imagePattern}
            imageName="010-engage-gift-card-com.jpg"
          />
          <h1>{t`Give a unisport giftcard`.toUpperCase()}</h1>
        </section>
        {/* END OF HEADER */}

        {/* INTRO TEXT */}
        <section className="introText_wrapper mainWidth">
          <div className="interiorWidth">
            <div className="introText">
              <h2>{t`Online Gift Cards`}</h2>
              {t`Are you in a rush, and in the need of an easy, though still awesome gift? Buy a gift card for someone you love online and make their day. Simply choose a design and select an amount of your choice. If you only order a gift card and don’t leave an order comment, the gift card will be delivered via e-mail instantly in your inbox, available for easy printing.`}
              <h2>{t`Quick and Easy Gift`}</h2>
              {jt`What you get is a digital gift card in size A4, with a club picture on the left and the voucher code on the right. It offers full access to all the latest gear on ${siteName}, so the receiver can pick just what he or she wants. Live the #unisportlife to its fullest.`}
            </div>
          </div>
        </section>
        {/* END OF INTRO TEXT */}

        {/* STEP 1 */}
        <section id="gc-step1" className="step-section mainWidth">
          <div className="interiorWidth">
            <h2 className="stepTitle">
              {t`Step`} {' 1'}
            </h2>
            <div className="stepText">{t`Choose your preferred design`}</div>
          </div>
          <div id="gift-product" className="grid-like interiorWidth">
            {giftcards.map(item => (
              <div key={item.id}>
                <img
                  role="button"
                  tabIndex={0}
                  className={item.selected ? 'outline' : ''}
                  onClick={() => {
                    this.setState(prevState => ({
                      giftcards: prevState.giftcards.map(el =>
                        el.id === item.id
                          ? { ...el, selected: true }
                          : { ...el, selected: false }
                      )
                    }));
                    this.scrollTo('gc-step2');
                  }}
                  src={item.src}
                  alt={item.name}
                />
                <p className="title">{item.name}</p>
              </div>
            ))}
          </div>
        </section>

        {/* END OF STEP 1 */}

        {/* STEP 2 */}
        <section id="gc-step2" className="step-section mainWidth">
          <div className="interiorWidth">
            <h2 className="stepTitle">
              {t`Step`} {' 2'}
            </h2>
            <div className="stepText">{t`Select an amount or enter your own amount`}</div>
            {/* check if loaded, map through products */}
          </div>

          <div id="gift-choices" className="grid-like interiorWidth">
            {this.returnPredefined(predefinedChoices, currency)}
          </div>
          <div className="input-wrapper interiorWidth">
            <input
              id="input-amount"
              className={
                isFocused && inputValue !== ''
                  ? 'interiorWidth form-control border-input'
                  : 'interiorWidth form-control'
              }
              type="number"
              value={inputValue}
              onFocus={e => {
                e.target.placeholder = '';
                this.setState({ isFocused: true });
              }}
              onBlur={e => {
                const { value } = e.target;

                if (value === '') {
                  e.target.placeholder = t`Enter your own amount`.toUpperCase();
                } else {
                  this.setState({
                    showInputInvalid: !this.validateInput(value)
                  });
                }
                this.setState({ isFocused: false });
              }}
              onChange={e => {
                const { value } = e.target;
                this.setState(prevState => ({
                  price: value,
                  inputValue: value,
                  predefinedChoices: prevState.initialPredefiendChoices
                }));
              }}
              placeholder={t`Enter your own amount`.toUpperCase()}
            />
            <p id="input-error">
              {showInputInvalid && t`Please enter a valid amount`}
            </p>
          </div>
        </section>

        {/* END OF STEP 3 */}

        {/* STEP 3 */}
        <section id="gc-step3" className="step-section mainWidth">
          <div className="interiorWidth">
            <h2 className="stepTitle">
              {t`Step`} {' 3'}
            </h2>
            <div className="stepText">{t`Add selected gift card to cart and pay`}</div>
            <CartCta
              title={t`Add to cart`}
              price={price}
              product_id={this.getSelected(giftcards)}
              err1={t`Oops, you need to pick a design`}
              err2={t`Oops, you need to select or enter an amount`}
              err3={t`Oops, you need to pick a design and an amount`}
              amountValid={this.validateInput(price)}
            />
          </div>
        </section>

        {/* END OF STEP 3 */}

        {/* BOTTOM SOCIAL */}
        <section className="seo-section">
          <div className="interiorWidth">
            <div className="seo-text interiorWidth">
              <h2>{t`Buy Online Gift Cards for the Football Player`}</h2>
              <p>{t`We at Unisport know it can sometimes be difficult to find the perfect gift. To help you out, and to make it all a bit easier, we give you the opportunity to buy the perfect gift. With a Unisport Gift Card you can never go wrong, and what’s even better, we made the process of purchasing your Gift Card online extremely simple and easy. Let us present the print-it-yourself-solution. Simply pick a Gift Card, choose the amount, make your order, receive your Gift Card in your mailbox, and lastly, print it – Simple as that.`}</p>

              <h3>{t`Design The Gift Card Yourself`}</h3>
              <p>{t`Design your Gift Card, so it fits the recipients favorite football club. Do something extraordinary for the football fan and choose designs from some of the biggest clubs in football. Get designs related to some of the biggest clubs in the world like Liverpool, Juventus, FC Barcelona and Manchester United printed on the Gift Card. This way you make the Gift Card stand out even more.`}</p>

              <h3>{t`Where To Use The Unisport Gift Card`}</h3>
              <p>{t`The Gift Card can only be used at Unisport. When you buy a Unisport Gift Card, you’ll receive a nice and personalized Gift Card, with a unique Gift Card ID. The Gift Card can obviously be used several times, as long as there’s still money on the Gift Card. If you want to order something that has a higher value than the gift certificate, then the balance can of course be paid with debit or credit card.`}</p>

              <h3>{t`How To Use The Unisport Gift Card`}</h3>
              <p>{t`It’s super easy to use and redeem your Gift Card. After you’ve found your favorite products, then just add it to the cart. At the cart you just fill in the box called “Add Gift Card” with the unique Gift Card ID shown on the gift certificate, and then click “”redeem”“– simple as that. Expect speedy delivery at Unisport.`}</p>
            </div>
          </div>
        </section>

        <section className="social-section mainWidth">
          <div className="innerWidth">
            <SocialText />
          </div>
        </section>
        {/* END OF BOTTOM SOCIAL */}
      </main>
    );
  }
}

export default App;
